import {ItemConfiguracao, InstalacaoProduto, Operacao, FTA} from './../../model/catalogo';
import {FiltroFTa2, Metadata2, Metadata, Fta2, FiltroAlteracaoEstado2, FTA2} from './../../model/filtros';
import {PesquisasFiltroApiService} from './../../service/api/pesquisas-filtro.api';
import {ModalService} from './../../service/modal.service';
import {DetalhamentoApiService} from './../../service/api/detalhamento.api';
import {CatalogoApiService} from './../../service/api/catalogo.api';
import {GlobalService} from './../../service/global.service';
import {TipoEstado, ModeloTemplate, TipoTemplate} from './../../model/constantes';
import {ConstantesApiService} from './../../service/api/constantes.api';
import {ResultadoFiltroFta2, FiltroPesquisaFTA2, FTAFamily} from '../../model/filtros';
import {Component, OnInit, HostListener} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {JQueryStatic} from 'jquery';
import {IMyDpOptions} from 'mydatepicker';
import {ServicoVinculado} from '../../model/catalogo';
import * as moment from 'moment';


declare var $: JQueryStatic;

@Component({
    selector: 'app-pesquisa-fluxo',
    templateUrl: './pesquisa-fluxo.component.html',
    // template: this.treeTable,
    styleUrls: ['./pesquisa-fluxo.component.css']
})
export class PesquisaFluxoComponent implements OnInit {

    constructor(
        // private formBuilder: FormBuilder,
        private router: Router,
        private modalService: ModalService,
        private constantesService: ConstantesApiService,
        private globalService: GlobalService,
        private detalhamentoApiService: DetalhamentoApiService,
        private pesquisaService: PesquisasFiltroApiService,
        public catalogoService: CatalogoApiService) {
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event != null) {
            if (event.keyCode === 13) {
                this.pesquisar(true);
            }
        }
    }

    userLogado: any = null;

    respostaDespacho = '';
    ftaDespachado = null;
    ftaExcluido = null;
    pesquisado = false;
    tipoOrdenacao = 'desc';
    colunaOrdenacao = 'fta';

    treeTable: string;

    //combos
    estados: Array<TipoEstado> = new Array<TipoEstado>();
    modelos: Array<TipoTemplate> = new Array<TipoTemplate>();
    servicos: Array<ServicoVinculado>;
    itensConfiguracao: Array<ItemConfiguracao>;
    instalacaoProdutos: Array<InstalacaoProduto>;
    operacoes: Array<Operacao>;

    isResultados: boolean = false;
    FTAs: ResultadoFiltroFta2 = new ResultadoFiltroFta2();
    listFtaFamily: Array<FTAFamily> = new Array<FTAFamily>();
    isMaisFiltros: boolean = true;
    index: number = 0;

    // formulario
    codigo = new FormControl('', []);
    versao = new FormControl('', []);
    alteracaoEstado = new FormControl('', []);
    nome = new FormControl('', []);
    descricao = new FormControl('', []);
    servicoVinculado = new FormControl('', []);


    modelo = new FormControl('', []);
    modelo2 = new FormControl('', []);
    contratoIED = new FormControl('', []);
    formatoIED = new FormControl('', []);

    tipoUsuario = new FormControl('', []);
    usuario = new FormControl('', []);


    alteracaoEstado2 = new FormControl('', []);
    dtInicio = new FormControl('', []);
    dtInicio2 = new FormControl('', []);
    dtFim = new FormControl('', []);
    matricula = new FormControl('', []);

    produtoTransmissao = new FormControl('', []);
    nomeInstalacao = new FormControl('', []);
    icVinculado = new FormControl('', []);
    eventoMin = new FormControl('', []);
    eventoMax = new FormControl('', []);
    tipoOperacao = new FormControl('', []);
    paramTransmNome = new FormControl('', []);
    paramTransmCont = new FormControl('', []);
    paramOperacaoNome = new FormControl('', []);
    paramOperacaoConteudo = new FormControl('', []);


    //paginacao
    pagina: number = 1;
    irpagina = new FormControl('', []);
    registrosPorPagina = new FormControl('5', []);

    //modal
    justificativaForm: FormGroup;
    ftaInativacao: FTA = new FTA();

    //date picker
    hoje: Date = new Date();
    myDatePickerOptions: IMyDpOptions = {
        dateFormat: 'dd/mm/yyyy',
        monthLabels: {
            1: 'Jan',
            2: 'Fev',
            3: 'Mar',
            4: 'Abr',
            5: 'Mai',
            6: 'Jun',
            7: 'Jul',
            8: 'Ago',
            9: 'Set',
            10: 'Out',
            11: 'Nov',
            12: 'Dez'
        },
        dayLabels: {su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab'},
        sunHighlight: true,
        satHighlight: true,
        editableDateField: false,
        todayBtnTxt: 'Hoje',
        firstDayOfWeek: 'su',
        maxYear: this.hoje.getFullYear(),
        openSelectorOnInputClick: true
    };

    ngAfterViewInit() {
        this.controlCollapse();
    }

    controlCollapse() {

        $('#datetimepicker1').datetimepicker({
            locale: 'pt-BR'
        });

        $('#datetimepicker2').datetimepicker({
            locale: 'pt-BR'
        });

        $('#majorCollapseFTA').click(function () {
            $('#collapseFTA').toggle(80);
            $('span', this).toggleClass('glyphicon glyphicon-chevron-down glyphicon glyphicon-chevron-up');
        });

        $('#majorCollapseIED').click(function () {
            $('#collapseIED').toggle(50);
            $('span', this).toggleClass('glyphicon glyphicon-chevron-down glyphicon glyphicon-chevron-up');
        });

        $('#majorCollapseCliente').click(function () {
            $('#collapseCliente').toggle(50);
            $('span', this).toggleClass('glyphicon glyphicon-chevron-down glyphicon glyphicon-chevron-up');
        });

        $('#majorCollapseEstado').click(function () {
            $('#collapseEstado').toggle(50);
            $('span', this).toggleClass('glyphicon glyphicon-chevron-down glyphicon glyphicon-chevron-up');
        });

        $('#majorCollapseOutros').click(function () {
            $('#collapseOutros').toggle(50);
            $('span', this).toggleClass('glyphicon glyphicon-chevron-down glyphicon glyphicon-chevron-up');
        });
    }


    ngOnInit() {

        sessionStorage.setItem('isModalMigracaoOpen', 'false');

        //inicia array vazio de ftas.
        this.FTAs.ftas = new Array<FTA2>();

        //monta combos da tela
        this.constantesService.buscaTipoEstado(0)
            .subscribe(
                estados => this.estados = estados as Array<TipoEstado>
            );

        //monta combo de modelos
        this.constantesService.buscaTipoModelo()
            .subscribe(response => {
                this.modelos = response.codigoTemplate;
            });

        //monta combo de serviços
        this.pesquisaService.filtraServico(null)
            .subscribe(
                listaServicos => {
                    this.servicos = listaServicos as Array<ServicoVinculado>;
                    this.verificaDuplicados(this.servicos);
                },
                erro => {
                    if (erro.status == 404) {
                        this.servicos = new Array<ServicoVinculado>();
                    }
                }
            );

        //monta combo de itemConfiguracao
        let filtroItemConfiguracao: Array<any> = new Array<any>();
        filtroItemConfiguracao.push({'filtroItemConfiguracao': {'tipoItemConfiguracao': 1}});
        this.pesquisaService.filtraItemConfiguracao(filtroItemConfiguracao)
            .subscribe(
                listaItens => {
                    this.itensConfiguracao = listaItens as Array<ItemConfiguracao>;
                },
                erro => {
                }
            );

        //monta combo de itemConfiguracao
        this.carregarComboNomeInstalacao();

        //monta combo de operacao
        let filtroOperacao: Array<any> = new Array<any>();
        this.pesquisaService.filtraOperacao(filtroItemConfiguracao)
            .subscribe(
                listaItens => {
                    this.operacoes = listaItens as Array<Operacao>;
                },
                erro => {
                }
            );


        this.montaTreeTable();

        this.justificativaForm = new FormGroup({
            justificativaInativacao: new FormControl('', [
                Validators.required,
                Validators.minLength(20),
                Validators.maxLength(300)
            ])
        });

    }

    abrirModal(): void {
        this.justificativaForm.reset();
        $('#justificativaModal').modal('show');
    }

    salvarJustificativa(): void {
        if (this.justificativaForm.valid) {
            this.alterarEstadoFTA(this.ftaInativacao, "inativa");
            $('#justificativaModal').modal('hide');
        }
    }

    verificaDuplicados(servico: Array<ServicoVinculado>) {
        for (let i in servico) {
            let valorComparado = servico[i];
            let cont = 0;
            for (let i in servico) {
                let nomeatual = servico[i].nome;
                let nomecomparado = valorComparado.nome;

                if (nomecomparado == nomeatual) {
                    cont += 1;
                    if (cont > 1) {
                        cont--;
                        if (valorComparado.codTipoEstado <= servico[i].codTipoEstado) {
                            servico.splice(servico.indexOf(valorComparado), 1);
                        }
                    }
                }
            }
        }
    }

    verificaInstalacaoDuplicada(itens: Array<InstalacaoProduto>) {
        for (let i in itens) {
            let valorComparado = itens[i];
            let cont = 0;
            for (let i in itens) {
                let nomeatual = itens[i].nomeInstalacao;
                let nomecomparado = valorComparado.nomeInstalacao;

                if (nomecomparado == nomeatual) {
                    cont += 1;
                    if (cont > 1) {
                        cont--;
                        if (valorComparado.codTipoEstado <= itens[i].codTipoEstado) {
                            itens.splice(itens.indexOf(valorComparado), 1);
                        }
                    }
                }
            }
        }
        return itens;
    }


    carregarComboNomeInstalacao() {
        this.globalService.loading = true;
        let filtrosInstalacao: Array<any> = new Array<any>();
        filtrosInstalacao.push({'filtroInstalacaoProduto': {'nomeItemConfiguracaoProduto': this.produtoTransmissao.value}});
        this.pesquisaService.filtraInstalacaoProduto(filtrosInstalacao)
            .subscribe(
                listaItens => {
                    this.instalacaoProdutos = this.verificaInstalacaoDuplicada(listaItens as Array<InstalacaoProduto>);
                    this.globalService.loading = false;
                },
                erro => {
                    this.instalacaoProdutos = new Array<InstalacaoProduto>();
                    this.globalService.loading = false;
                }
            );
    }

    recuperaClasseOrdenacao() {
        let classeOrdenacao = '';
        if (this.FTAs.ftas.length > 0) {
            classeOrdenacao = 'tablesorter-header tablesorter-headerUnSorted';
        }
        return classeOrdenacao;
    }

    /**
     * método que monda dinamicamente a grid de pesquisa com efeito arvore
     */
    montaTreeTable() {

        let treeTable = '';
        treeTable = '<table id=\'treeTable\' class=\'table table-hover table-bordered tablesorter-blue\'>';
        treeTable += '<thead>';
        treeTable += '<tr>';
        treeTable += '<th class=\'col-md-1 col-fta ' + this.recuperaClasseOrdenacao() + '\'>Número</th>';
        treeTable += '<th class=\'col-md-1\'>Versão</th>';
        treeTable += '<th class=\'col-md-3 col-nome ' + this.recuperaClasseOrdenacao() + '\'>Nome</th>';
        treeTable += '<th class=\'col-md-4 col-descricao ' + this.recuperaClasseOrdenacao() + '\'>Descrição</th>';
        treeTable += '<th class=\'col-md-2 col-data ' + this.recuperaClasseOrdenacao() + '\'>Data Criação</th>';
        treeTable += '<th class=\'col-md-3 col-modelo ' + this.recuperaClasseOrdenacao() + '\'>Modelo</th>';
        treeTable += '<th class=\'col-md-3 col-estado ' + this.recuperaClasseOrdenacao() + '\'>Estado</th>';
        treeTable += '<th class=\'col-md-1\'></th>';
        treeTable += '</tr>';
        treeTable += '</thead>';
        treeTable += '<tbody>';

        if (this.FTAs != null) {
            if (this.FTAs.ftas.length == 0) {
                if (this.pesquisado) {
                    treeTable += '<td colspan=\'8\' class=\'text-center\'>Nenhum FTA corresponde à pesquisa.</td></tbody>';
                } else {
                    treeTable += '<td colspan=\'8\' class=\'text-center\'></td></tbody>';
                }

            } else {
                this.FTAs.ftas.forEach((fta, index) => {
                    let numeroFta = index + 1;
                    if (fta.versoes.length == 1) {
                        treeTable += '<tr data-node-id=\'' + numeroFta + '\'>';
                        treeTable += '<td>' + fta.fta + '</td>';
                        treeTable += '<td>' + fta.versoes[0].versao + '</td>';
                        treeTable += '<td>' + fta.versoes[0].nome + '</td>';
                        treeTable += '<td>' + fta.versoes[0].descricao + '</td>';
                        treeTable += '<td>' + this.formataData(fta.versoes[0].dataCriacao) + '</td>';
                        treeTable += '<td align=\'center\'>' + this.getModelo(fta.versoes[0].codModelo) + '</td>';
                        treeTable += '<td>' + this.getEstado(fta.versoes[0].codTipoEstado) + '</td>';
                        treeTable += this.montaAcoesTemplate(fta.fta, fta.versoes[0].versao, fta.versoes[0].codModelo, fta.versoes[0].indicadorExclusao, fta.versoes[0].codTipoEstado, fta.versoes[0].indicadorStepRoteiroPendenteDemandante, fta.versoes[0].indicadorStepRoteiroPendenteSuporte, 0);
                        treeTable += '</tr>';
                    } else {
                        treeTable += '<tr data-node-id=\'' + fta.fta + '\' data-node-pid=\'\' >';
                        treeTable += '<td>' + fta.fta + '</td>';
                        treeTable += '<td>' + fta.versoes[0].versao + '</td>';
                        treeTable += '<td>' + fta.versoes[0].nome + '</td>';
                        treeTable += '<td>' + fta.versoes[0].descricao + '</td>';
                        treeTable += '<td>' + this.formataData(fta.versoes[0].dataCriacao) + '</td>';
                        treeTable += '<td align=\'center\'>' + this.getModelo(fta.versoes[0].codModelo) + '</td>';
                        treeTable += '<td>' + this.getEstado(fta.versoes[0].codTipoEstado) + '</td>';
                        treeTable += this.montaAcoesTemplate(fta.fta, fta.versoes[0].versao, fta.versoes[0].codModelo, fta.versoes[0].indicadorExclusao, fta.versoes[0].codTipoEstado, fta.versoes[0].indicadorStepRoteiroPendenteDemandante, fta.versoes[0].indicadorStepRoteiroPendenteSuporte, 0);
                        treeTable += '</tr>';
                        fta.versoes.forEach((versao, i) => {
                            if (i > 0) {
                                treeTable += '<tr align=\'right\' data-node-id=\'' + fta.fta + '.' + versao.versao + '\' data-node-pid=\'' + fta.fta + '\' class=\'active\'>';
                                treeTable += '<td>' + fta.fta + '</td>';
                                treeTable += '<td>' + fta.versoes[i].versao + '</td>';
                                treeTable += '<td>' + fta.versoes[i].nome + '</td>';
                                treeTable += '<td>' + fta.versoes[i].descricao + '</td>';
                                treeTable += '<td>' + this.formataData(fta.versoes[i].dataCriacao) + '</td>';
                                treeTable += '<td align=\'center\'>' + this.getModelo(fta.versoes[i].codModelo) + '</td>';
                                treeTable += '<td>' + this.getEstado(fta.versoes[i].codTipoEstado) + '</td>';
                                treeTable += this.montaAcoesTemplate(fta.fta, fta.versoes[i].versao, fta.versoes[i].codModelo, fta.versoes[i].indicadorExclusao, fta.versoes[i].codTipoEstado, fta.versoes[i].indicadorStepRoteiroPendenteDemandante, fta.versoes[i].indicadorStepRoteiroPendenteSuporte, i);
                                treeTable += '</tr>';
                            }
                        });
                    }
                });
            }
        }
        treeTable += '</tbody></table>';
        this.treeTable = treeTable;

        //renderiza o html da grid na div principal
        $('#templateTreeTable').html(treeTable);

        //monta a grid com efeito arvore
        $('#treeTable').simpleTreeTable({
            opened: [0]
        });

        //ajusta tabela com plugin de ordenacao.
        // $("#treeTable").tablesorter({
        //   dateFormat: "ddmmyyyy",
        //   headers: {
        //     // Desativa a ordenação para essa coluna
        //     1: { sorter: false },
        //     7: { sorter: false }
        //   }
        // });


        //dispara o controle de acoes do dropdown
        this.disparaControleAcoes();
    }

    montaAcoesTemplate(codFTA, versaoFTA, codModelo, indicadorExlusao, codTipoEstado, isStepDemandante, isStepSuporte, index): string {
        this.index++;
        let acoes = '';
        this.userLogado = this.globalService.getUsuario();
        acoes += '<td><div class=\'btn-group\'>';
        acoes += '<button type=\'button\' class=\'btn btn-default dropdown-toggle\' data-toggle=\'dropdown\' aria-haspopup=\'true\' aria-expanded=\'false\'><span>Ações&nbsp;</span><span class=\'caret\'></span></button>';
        acoes += '<input type=\'hidden\' id=\'codigo_campo_' + this.index + '\' value=\'' + codFTA + '\'/>';
        acoes += '<input type=\'hidden\' id=\'versao_campo_' + this.index + '\' value=\'' + versaoFTA + '\'/>';
        acoes += '<input type=\'hidden\' id=\'cod_modelo_' + this.index + '\' value=\'' + codModelo + '\'/>';
        acoes += '<input type=\'hidden\' id=\'indicador_exclusao_' + this.index + '\' value=\'' + indicadorExlusao + '\'/>';
        acoes += '<input type=\'hidden\' id=\'is_step_demandante_' + this.index + '\' value=\'' + isStepDemandante + '\'/>';
        acoes += '<input type=\'hidden\' id=\'is_step_suporte_' + this.index + '\' value=\'' + isStepSuporte + '\'/>';
        acoes += '<ul class=\'dropdown-menu\'>';
        acoes += '<li><a id=\'detalhar_' + this.index + '\'>' + 'Detalhar</a></li>';
        acoes += '<li><a id=\'editar_' + this.index + '\'>' + 'Editar</a></li>';
        acoes += '<li><a id=\'copiar_' + this.index + '\'>' + 'Copiar</a></li>';
        acoes += '<li><a id=\'migrar_' + this.index + '\'>' + 'Migrar</a></li>';

        if (!indicadorExlusao && this.userLogado.scope.indexOf('GMTCAT05') != -1) {
            acoes += '<li><a id=\'excluir_' + this.index + '\'>' + 'Excluir</a></li>';
        }

        if (indicadorExlusao && this.userLogado.scope.indexOf('GMTCAT06') != -1) {
            acoes += '<li><a id=\'confirmarExlusao_' + this.index + '\'>' + 'Confirmar exclusão</a></li>';
        }

        if (isStepDemandante == true || isStepSuporte == true) {
            if (this.userLogado.scope.indexOf('GMTCAT10') != -1) {
                acoes += '<li><a id=\'roteiro_' + this.index + '\'>' + 'Roteiro</a></li>';
            } else {
                acoes += '<li><a title=\'Usuário não possui a permissão GMTCAT10\' style=\'color: #aba7a7\'><span class=\'glyphicon glyphicon-ban-circle\'/>&nbsp;Roteiro</a></li>';
            }
        }

        acoes += '<li role=\'separator\' class=\'divider\'></li>';

        if (this.userLogado.scope.indexOf('GMTCAT07') != -1 && codTipoEstado == '1') {
            acoes += '<li><a id=\'despachar_' + this.index + '\'>' + 'Despachar</a></li>';
        }

        if (this.userLogado.scope.indexOf('GMTCAT09') != -1 && codTipoEstado == '2') {
            acoes += '<li><a id=\'aprovar_' + this.index + '\'>' + 'Aprovar</a></li>';
        }

        if (this.userLogado.scope.indexOf('GMTCAT08') != -1 && (codTipoEstado == '3' || codTipoEstado == '5')) {
            acoes += '<li><a id=\'ativar_' + this.index + '\'>' + 'Ativar</a></li>';
        }

        if (this.userLogado.scope.indexOf('GMTCAT08') != -1 && codTipoEstado == '4') {
            acoes += '<li><a id=\'inativar_' + this.index + '\'>' + 'Inativar</a></li>';
        }
        acoes += '</ul>';
        acoes += '</div></td>';
        return acoes;
    }

    disparaControleAcoes() {
        let codigo;
        let versao;

        //controle de ordenacao
        $('.col-fta').click(() => {
            this.colunaOrdenacao = 'fta';
            if (this.tipoOrdenacao == 'desc') {
                this.tipoOrdenacao = 'asc';
                this.pesquisar(false);
            } else {
                this.tipoOrdenacao = 'desc';
                this.pesquisar(false);
            }
        });

        $('.col-nome').click(() => {
            this.colunaOrdenacao = 'nome';
            if (this.tipoOrdenacao == 'desc') {
                this.tipoOrdenacao = 'asc';
                this.pesquisar(false);
            } else {
                this.tipoOrdenacao = 'desc';
                this.pesquisar(false);
            }
        });

        $('.col-descricao').click(() => {
            this.colunaOrdenacao = 'descricao';
            if (this.tipoOrdenacao == 'desc') {
                this.tipoOrdenacao = 'asc';
                this.pesquisar(false);
            } else {
                this.tipoOrdenacao = 'desc';
                this.pesquisar(false);
            }
        });

        $('.col-data').click(() => {
            this.colunaOrdenacao = 'dataCriacao';
            if (this.tipoOrdenacao == 'desc') {
                this.tipoOrdenacao = 'asc';
                this.pesquisar(false);
            } else {
                this.tipoOrdenacao = 'desc';
                this.pesquisar(false);
            }
        });

        $('.col-modelo').click(() => {
            this.colunaOrdenacao = 'codModelo';
            if (this.tipoOrdenacao == 'desc') {
                this.tipoOrdenacao = 'asc';
                this.pesquisar(false);
            } else {
                this.tipoOrdenacao = 'desc';
                this.pesquisar(false);
            }
        });

        $('.col-estado').click(() => {
            this.colunaOrdenacao = 'codTipoEstado';
            if (this.tipoOrdenacao == 'desc') {
                this.tipoOrdenacao = 'asc';
                this.pesquisar(false);
            } else {
                this.tipoOrdenacao = 'desc';
                this.pesquisar(false);
            }
        });

        //controle de acoes
        for (let i = 1; i <= this.index; i++) {
            $('#detalhar_' + i).click(() => {
                codigo = $('#codigo_campo_' + i).val();
                versao = $('#versao_campo_' + i).val();
                this.detalhesFTA(codigo, versao);
            });

            $('#editar_' + i).click(() => {
                let fta: FTA = new FTA();
                fta.fta = $('#codigo_campo_' + i).val();
                fta.versao = $('#versao_campo_' + i).val();
                fta.codModelo = $('#cod_modelo_' + i).val();
                this.editarFTA(fta);
            });

            $('#copiar_' + i).click(() => {
                let fta: FTA = new FTA();
                fta.fta = $('#codigo_campo_' + i).val();
                fta.versao = $('#versao_campo_' + i).val();
                this.copiarFTA(fta);
            });

            $('#migrar_' + i).click(() => {
                let fta: FTA = new FTA();
                fta.fta = $('#codigo_campo_' + i).val();
                fta.versao = $('#versao_campo_' + i).val();
                this.migrarFTA(fta);
            });

            $('#excluir_' + i).click(() => {
                let fta: FTA = new FTA();
                fta.fta = $('#codigo_campo_' + i).val();
                fta.versao = $('#versao_campo_' + i).val();
                fta.codModelo = $('#cod_modelo_' + i).val();
                this.excluirFTA(fta);
            });

            $('#confirmarExlusao_' + i).click(() => {
                let fta: FTA = new FTA();
                fta.fta = $('#codigo_campo_' + i).val();
                fta.versao = $('#versao_campo_' + i).val();
                fta.codModelo = $('#cod_modelo_' + i).val();
                this.excluirFTA(fta);
            });

            $('#despachar_' + i).click(() => {
                let fta: FTA = new FTA();
                fta.fta = $('#codigo_campo_' + i).val();
                fta.versao = $('#versao_campo_' + i).val();
                fta.codModelo = $('#cod_modelo_' + i).val();
                this.alterarEstadoFTA(fta, 'despacha');
            });

            $('#ativar_' + i).click(() => {
                let fta: FTA = new FTA();
                fta.fta = $('#codigo_campo_' + i).val();
                fta.versao = $('#versao_campo_' + i).val();
                fta.codModelo = $('#cod_modelo_' + i).val();
                this.alterarEstadoFTA(fta, 'ativa');
            });

            $('#aprovar_' + i).click(() => {
                let fta: FTA = new FTA();
                fta.fta = $('#codigo_campo_' + i).val();
                fta.versao = $('#versao_campo_' + i).val();
                fta.codModelo = $('#cod_modelo_' + i).val();
                this.alterarEstadoFTA(fta, 'aprova');
            });

            $('#inativar_' + i).click(() => {
                let fta: FTA = new FTA();
                fta.fta = $('#codigo_campo_' + i).val();
                fta.versao = $('#versao_campo_' + i).val();
                fta.codModelo = $('#cod_modelo_' + i).val();
                this.abrirModal();
                this.ftaInativacao = fta;
                // this.alterarEstadoFTA(fta, 'inativa');
            });

            $('#roteiro_' + i).click(() => {
                let fta: FTA = new FTA();
                fta.fta = $('#codigo_campo_' + i).val();
                fta.versao = $('#versao_campo_' + i).val();
                fta.indicadorStepRoteiroPendenteDemandante = $('#is_step_demandante_' + i).val();
                this.consultaRoteiro(fta);
            });
        }
    }

    detalhesFTA(codigo, versao) {
        this.modalService.abrirPaginaModal('detalhe-fta-modal', {}, {
            'codigo': codigo,
            'versao': versao
        }, 'Detalhes FTA', 'Fechar');
    }

    editarFTA(fta: FTA) {
        this.router.navigate(['/fluxo-cliente-interno-completo', fta.fta, fta.versao]);
    }

    copiarFTA(fta: FTA) {
        this.router.navigate(['/fluxo-cliente-interno-completo', fta.fta, fta.versao, 'S']);
    }

    migrarFTA(fta: FTA) {
        this.modalService.abrirPaginaModal('migracao-fta-modal', {}, {
            'codFTA': fta.fta,
            'vrsFTA': fta.versao
        }, 'Migração de FTA', 'Fechar').subscribe(
            response => {
                if (response != null) {
                    if (response.codigo == 200) {
                        this.modalService.exibirMensagem('Sucesso', response.mensagem, 'Fechar');
                    }
                    if (response.codigo == 500) {
                        this.modalService.exibirMensagem('Erro', response.mensagem, 'Fechar');
                    }
                }
            });
    }

    excluirFTA(fta: FTA) {
        this.globalService.loading = true;
        this.catalogoService.deletaArtefatoFta(fta.fta, fta.versao, 'fta', 'FTA excluído.')
            .subscribe(resposta => {
                    this.globalService.loading = false;
                    this.modalService.exibirMensagem('Sucesso', 'Fluxo de Transmissão de Arquivo número <b>' + fta.fta + '</b> excluído com sucesso!', 'Fechar');
                    this.pesquisar(true);
                },
                erro => {
                    this.globalService.loading = false;
                    this.modalService.exibirMensagem('Atenção', 'Não foi possível excluir o FTA. <br>' + erro.error.mensagem, 'Fechar');
                }
            );
    }


    alterarEstadoFTA(fta: FTA, tipoOperacao: string) {
        let msgSucesso = '';
        let msgErro = '';
        let msgAtualizacao = '';

        switch (tipoOperacao) {
            case 'despacha':
                msgAtualizacao = 'Item despachado pelo sistema de Administração Web.';
                break;
            case 'aprova':
                msgAtualizacao = 'Item aprovado pelo sistema de Administração Web.';
                break;
            case 'ativa':
                msgAtualizacao = 'Item ativado pelo sistema de Administração Web.';
                break;
            case 'inativa':
                msgAtualizacao = this.justificativaForm.value.justificativaInativacao;
                break;
        }

        this.globalService.loading = true;
        this.catalogoService.alterarEstadoFTA(fta.fta, fta.versao, tipoOperacao, msgAtualizacao)
            .subscribe(
                response => {
                    this.globalService.loading = false;
                    this.modalService.exibirMensagem('Sucesso', response.mensagem, 'Fechar');
                    this.pesquisar(true);
                },
                erro => {
                    this.globalService.loading = false;
                    if (erro.status == 404 || erro.status == 400 || erro.status == 500) {
                        this.modalService.exibirMensagem('Erro', erro.error.mensagem, 'Fechar');
                    } else if (erro.status == 403) {
                        this.modalService.exibirMensagem('Erro', 'Você não possui permissão para efetuar a operação', 'Fechar');
                    } else {
                        this.modalService.exibirMensagem('Erro', 'Não foi possível realizar a operação', 'Fechar');
                    }
                }
            );

    }

    // método que busca o produto origem usando o (componente de modal) com a API Rest
    consultaRoteiro(fta: any) {

        this.pesquisaService.detalhaFtaRoteiro(fta.fta, fta.versao)
            .subscribe(
                rs => {
                    let resultado = rs as any;
                    let msgIteracao = '';
                    // resultado.codInteracaoDoGSTIParaAdministracaoExecutarRoteiro = 1;
                    if (resultado.codInteracaoDoGSTIParaAdministracaoExecutarRoteiro != null) {
                        msgIteracao = ' - Interação: ' + resultado.codInteracaoDoGSTIParaAdministracaoExecutarRoteiro;
                    }
                    this.modalService.abrirPaginaModal('roteiro-fta-modal', {}, {
                        'codFTA': fta.fta,
                        'vrsFTA': fta.versao
                    }, `Roteiro do FTA nr. ${fta.fta} v. ${fta.versao} ${msgIteracao}`, 'Fechar').subscribe(
                        produto => {
                            if (produto != null) {

                            }
                        });

                },
                erro => {
                    if (erro.status == 404) {
                    }
                }
            );
    }

    getEstado(codigo: number) {
        let estado = this.estados.find(x => x.codigo == codigo);
        if (estado != null) {
            return estado.descricao;
            // return estado.nome;
        }
        return '-';
    }

    getModelo(codigo: number) {
        let modelo = this.modelos.find(x => x.cod == codigo);
        if (modelo != null) {
            // return estado.descricao;
            return modelo.cod + ' - ' + modelo.nomeAdministracao;
        }
        return '-';
    }

    formataData(dt): string {
        var data = new Date(dt);
        return data.toLocaleString();
    }

    proximaPagina(desabilitado: string) {
        if (desabilitado == 'true') {
            return false;
        }
        this.pagina++;
        this.pesquisar(false);
    }

    paginaAnterior(desabilitado: string) {
        if (desabilitado == 'true') {
            return false;
        }
        this.pagina--;
        this.pesquisar(false);
    }

    IrparaPargina() {
        if (this.irpagina.value == '') {
            this.pagina = 1;
        } else {
            this.pagina = this.irpagina.value;
        }
        this.pesquisar(false);
    }

    alterarRegistrosPorPagina() {
        if (this.registrosPorPagina.value != null && this.registrosPorPagina.value != '') {
            this.pesquisar(false);
        }
    }

    pesquisar(isZerarPagina: boolean) {

        if (isZerarPagina) {
            this.pagina = 1;
        }

        let filtros: FiltroPesquisaFTA2 = new FiltroPesquisaFTA2();
        filtros.incluirTodasVersoesFTA = true;
        let filtroFta2: FiltroFTa2 = new FiltroFTa2();
        let fta2: Fta2 = new Fta2();
        filtroFta2.filtroFta = fta2;
        filtroFta2.filtroAlteracaoEstado = new FiltroAlteracaoEstado2();
        filtros.filtros = new Array<FiltroFTa2>();

        filtros.metadata = new Metadata2();
        filtros.metadata.pagina = this.pagina;

        filtros.metadata.colunaOrdenacao = this.colunaOrdenacao;
        filtros.metadata.ordenacao = this.tipoOrdenacao;

        if (this.registrosPorPagina.value != null && this.registrosPorPagina.value != '') {
            filtros.metadata.porPagina = this.registrosPorPagina.value;
        } else {
            filtros.metadata.porPagina = 10;
        }


        this.pesquisado = true;

        if ((this.dtInicio.value == '' && this.dtFim.value != '') || (this.dtInicio.value != '' && this.dtFim.value == '')) {
            this.modalService.exibirMensagem('Data de Criação', 'Por favor, preencha as datas de criação inicial e final ou deixe os dois campos em branco.', 'Fechar');
            return false;
        }

        //PRIMEIRO BLOCO - fta
        if (this.codigo.value != '') {
            filtroFta2.filtroFta.fta = this.codigo.value;
        }
        if (this.versao.value != '') {
            filtroFta2.filtroFta.versao = this.versao.value;
        }
        if (this.alteracaoEstado.value != '') {
            filtroFta2.filtroFta.codTipoEstado = this.alteracaoEstado.value;
        }
        if (this.nome.value != '') {
            filtroFta2.filtroFta.nome = this.nome.value;
        }
        if (this.descricao.value != '') {
            filtroFta2.filtroFta.descricao = this.descricao.value;
        }
        if (this.modelo.value != '') {
            filtroFta2.filtroFta.modeloMin = this.modelo.value;
        }
        if (this.modelo2.value != '') {
            filtroFta2.filtroFta.modeloMax = this.modelo2.value;
        }
        if (this.servicoVinculado.value != '') {
            filtroFta2.filtroFta.nomeServicoVinculado = this.servicoVinculado.value;
        }

        //SEGUNDO BLOCO - contrato
        if (this.contratoIED.value != '') {
            filtroFta2.filtroFta.contratoIed = this.contratoIED.value;
        }
        if (this.formatoIED.value != '') {
            filtroFta2.filtroFta.formatoIed = this.formatoIED.value;
        }

        //TERCEIRO BLOCO - user
        if (this.tipoUsuario.value != '') {
            if (this.tipoUsuario.value == '1') {
                filtroFta2.filtroFta.nomeUsrImpessoal = this.usuario.value.toLowerCase();
            } else if (this.tipoUsuario.value == '2') {
                filtroFta2.filtroFta.codMci = this.usuario.value.toLowerCase();
            } else if (this.tipoUsuario.value == '3') {
                filtroFta2.filtroFta.codUor = this.usuario.value.toLowerCase();
            }
        }

        //QUARTO BLOCO - alteracao estado
        if (this.alteracaoEstado2.value != '' && this.alteracaoEstado2.value != null) {
            filtroFta2.filtroAlteracaoEstado.codTipoEstado = this.alteracaoEstado2.value;
        }

        let dateTime1, dateTime2;
        if ($('#dtInicio').val() != '' && $('#dtInicio').val() != null) {
            let dateTimeTela1 = $('#dtInicio').val();
            let dateTimeString = dateTimeTela1.split(' ');
            let data = dateTimeString[0].split('/');
            let hora = dateTimeString[1].split(':');
            dateTime1 = new Date(data[2] + '-' + data[1] + '-' + data[0] + ' ' + hora[0] + ':' + hora[1]);
            filtroFta2.filtroAlteracaoEstado.dataInicial = dateTime1.toISOString();
        }
        if ($('#dtFim').val() != '' && $('#dtFim').val() != null) {
            let dateTimeTela2 = $('#dtFim').val();
            let dateTimeString2 = dateTimeTela2.split(' ');
            let data = dateTimeString2[0].split('/');
            let hora = dateTimeString2[1].split(':');
            dateTime2 = new Date(data[2] + '-' + data[1] + '-' + data[0] + ' ' + hora[0] + ':' + hora[1]);
            filtroFta2.filtroAlteracaoEstado.dataFinal = dateTime2.toISOString();
        }
        if (this.matricula.value != '' && this.matricula.value != null) {
            filtroFta2.filtroAlteracaoEstado.matricula = this.matricula.value;
        }

        //QUINTO BLOCO - outras opcoes
        //TODO FAZER ESSE BLOCO
        if (this.produtoTransmissao.value != '' && this.produtoTransmissao.value != null) {
            filtroFta2.filtroFta.nomeProdutoTransmissao = this.produtoTransmissao.value;
        }
        if (this.nomeInstalacao.value != '' && this.nomeInstalacao.value != null) {
            filtroFta2.filtroFta.nomeInstalacaoProduto = this.nomeInstalacao.value;
        }
        if (this.icVinculado.value != '' && this.icVinculado.value != null) {
            filtroFta2.filtroFta.itemConfiguracaoVinculado = this.icVinculado.value;
        }
        if (this.eventoMin.value != '' && this.eventoMin.value != null) {
            filtroFta2.filtroFta.qtdEventosMin = this.eventoMin.value;
        }
        if (this.eventoMax.value != '' && this.eventoMax.value != null) {
            filtroFta2.filtroFta.qtdEventosMax = this.eventoMax.value;
        }
        if (this.tipoOperacao.value != '' && this.tipoOperacao.value != null) {
            filtroFta2.filtroFta.nomeOperacaoVinculada = this.tipoOperacao.value;
        }
        if (this.paramTransmNome.value != '' && this.paramTransmNome.value != null) {
            filtroFta2.filtroFta.parametroTransmissaoNome = this.paramTransmNome.value;
        }
        if (this.paramTransmCont.value != '' && this.paramTransmCont.value != null) {
            filtroFta2.filtroFta.parametroTransmissaoConteudo = this.paramTransmCont.value;
        }
        if (this.paramOperacaoNome.value != '' && this.paramOperacaoNome.value != null) {
            filtroFta2.filtroFta.parametroOperacaoNome = this.paramOperacaoNome.value;
        }
        if (this.paramOperacaoConteudo.value != '' && this.paramOperacaoConteudo.value != null) {
            filtroFta2.filtroFta.parametroOperacaoConteudo = this.paramOperacaoConteudo.value;
        }

        filtros.filtros.push(filtroFta2);

        if ($('#dtInicio').val() != '' && $('#dtInicio').val() != null &&
            $('#dtFim').val() != '' && $('#dtFim').val() != null
        ) {
            if (dateTime2 < dateTime1) {
                this.modalService.exibirMensagem('Erro!', 'A data final não pode ser maior que a data inicial', 'Fechar');
                return;
            }
        }

        this.globalService.loading = true;
        // this.pesquisaService.mudarPagina(this.pagina);
        this.pesquisaService.filtraFta2(filtros)
            .subscribe(
                listaItens => {
                    this.globalService.loading = false;
                    this.FTAs = listaItens as ResultadoFiltroFta2;
                    this.ajustaFTAFamily();
                    if (this.FTAs.ftas.length > 0) {
                        this.isResultados = true;
                    } else {
                        this.isResultados = false;
                    }
                },
                erro => {
                    this.isResultados = false;
                    this.globalService.loading = false;
                    let msg = '';
                    if (erro.status == 500) {
                        var objErro = JSON.parse(erro._body);
                        if (objErro.mensagem == '') {
                            msg = 'Erro durante realização da pesquisa.';
                        } else {
                            msg = objErro.mensagem;
                        }
                    }

                    if (erro.status == 403) {
                        msg = 'Usuário não possui permissão para uso do CADASTRO-WEB';
                    }

                    if (erro.status == 404 || erro.status == 405) {
                        msg = 'Serviço de pesquisa indisponível. Tente novamente mais tarde';
                    }

                    if (erro.name != undefined) {
                        if (erro.name == 'TimeoutError') {
                            msg = 'Timeout na API de pesquisa. Favor verifique o status de sua conexão';
                        }
                    }

                    this.modalService.exibirMensagem('Erro!', msg, 'Fechar');
                    this.FTAs = new ResultadoFiltroFta2();
                    let metadata = new Metadata();
                    this.FTAs.ftas = new Array<FTA2>();
                    metadata.paginaAtual = 1;
                    this.FTAs.metadata = metadata;
                    this.montaTreeTable();
                }
            );
    }

    ajustaFTAFamily() {
        this.FTAs.ftas.forEach((fta1, index) => {
            fta1.versoes.forEach(fta => {
                let ftaFamily: FTAFamily = new FTAFamily();
                ftaFamily.codFTA = fta1.fta.toString();
                if (fta.versao == 1) {
                    ftaFamily.codFTAPai = '';
                } else {
                    ftaFamily.codFTAPai = fta1.fta.toString();
                }
                ftaFamily.codModelo = fta.codModelo;
                ftaFamily.codTipoEstado = fta.codTipoEstado;
                ftaFamily.contratoIed = fta.contratoIed;
                ftaFamily.dataCriacao = fta.dataCriacao;
                ftaFamily.descricao = fta.descricao;
                ftaFamily.formatoIed = fta.formatoIed;
                ftaFamily.indicadorAtendimentoFiltros = fta.indicadorAtendimentoFiltros;
                ftaFamily.indicadorExclusao = fta.indicadorAtendimentoFiltros;
                ftaFamily.nome = fta.nome;
                ftaFamily.versao = fta1.fta + '.' + fta.versao;
                this.listFtaFamily.push(ftaFamily);
            });
        });
        this.montaTreeTable();
    }
}





// WEBPACK FOOTER //
// ./src/app/pesquisa-fluxo/pesquisa-fluxo.component.ts